document.addEventListener("DOMContentLoaded", function() {
  const variantButtons = document.querySelectorAll('.opt-label--btn');
  const priceElement = document.querySelector('.price__current');

  variantButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const labelText = button.querySelector('span').textContent.trim();

      // Check if the label contains "60 Capsules"
      if (labelText.includes("60 Capsules")) {
        console.log("60 Capsules variant selected");
        
        // Show both ::after and ::before pseudo-elements of the price element
        if (priceElement) {
          priceElement.classList.add('show-after', 'show-before');
        }
      } else {
        // Hide both ::after and ::before pseudo-elements
        if (priceElement) {
          priceElement.classList.remove('show-after', 'show-before');
        }
      }
    });
  });
});
